<template>
  <div class="multi-select">
    <multiselect
      :options="options" v-model="selectedItems" :multiple="true" :track-by="trackByAttribute"
      :custom-label="translateObjectForSelect" label="label" :searchable="true"
      :selectLabel="$t('add')" :deselectLabel="$t('remove')" :selectedLabel="''"
      :placeholder="''" :hide-selected="hideSelected" :disabled="disabled"
    />
  </div>
</template>

<script>

  export default {

    name: "multi-select",

    props: {
      /**
       * name attribute to match optional label element
       */
      options: {
        type: Array,
      },
      /**
       * name attribute to match optional label element
       */
      selected: {
        type: Array,
      },
      /**
       * name attribute to match optional label element
       */
      trackByAttribute: {
        type: String,
        default: 'id'
      },
      /**
       * name attribute to match optional label element
       */
      hideSelected: {
        type: Boolean,
        default: true
      },

      disabled: {
        type: Boolean,
        default: false
      },

      label: {
        type: String,
        default: 'label'
      },
    },

    watch: {
      selected: function() {
        this.selectedItems = this.selected;
      },

      selectedItems: function() {
        this.$emit("changed", this.selectedItems);
      }
    },

    data() {
      return {
        selectedItems: Array,
      };
    },

    mounted() {
      this.selectedItems = this.selected;
    },

    methods: {
      translateObjectForSelect(object) {
        if (object && object[this.label]) {
          return typeof object[this.label] == 'object' ? translateObject(object[this.label]) : object[this.label];
        }
        return ' ';
      },
    }

  }

</script>

<style lang="scss">

  .multi-select.disabled {
    pointer-events: none !important;
    opacity: 0.6;
    cursor: not-allowed;

    * {
      pointer-events: none !important;
      cursor: not-allowed;
    }
  }

  #app .multiselect {
    .multiselect__content-wrapper {
      border: 1px solid #d9d9d9;
      border-top: none;

      .multiselect__option--highlight,
      .multiselect__option--highlight:after {
        background: #fc6650;
      }

      .multiselect__option--selected.multiselect__option--highlight,
      .multiselect__option--selected.multiselect__option--highlight:after {
        background: var(--primary-color);
      }
    }
    .multiselect__tags {
      padding: 9.5px 40px 0 9.5px;
      border: 1px solid #d9d9d9;
      .multiselect__tags-wrap .multiselect__tag {
        background-color: #e6e6e6;
        color: #35495e;

        .multiselect__tag-icon:focus,
        .multiselect__tag-icon:hover {
          background: #b3b3b3;
        }

        .multiselect__tag-icon:focus:after,
        .multiselect__tag-icon:hover:after {
          color: white;
        }

        .multiselect__tag-icon::after {
          color: #b3b3b3;
        }
      }
    }
    &:not(.multiselect--active) {
    .multiselect__input {
      border: none;
    }
   }
  }
</style>
